// @flow
import {
	WebComponent,
} from 'fg-frontend';
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.triggerInViewport';

export default class TriggerInViewport extends WebComponent {
	didMount() {
		const {
			triggerInViewportTargetItem,
			triggerInViewportTriggerEventOn,
		} = this.props;

		$(this.element).triggerInViewport({
			'targetItem': triggerInViewportTargetItem || null,
			'triggerEventOn': triggerInViewportTriggerEventOn || null,
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/TriggerInViewport.js